// extracted by mini-css-extract-plugin
export var csatScore = "_nw-5";
export var header = "_nw-1";
export var panelWrapper = "_nw-2";
export var postPreview = "_nw-3";
export var rightContent = "_nw-0";
export var wrappingText = "_nw-4";